module.exports = "label::before {\n\tcontent: none;\n}\n\nlabel {\n\tpadding: 0;\n}\n\n.extra-job-info > span {\n\twidth: 100%;\n}"